import PropTypes from "prop-types";
import React from "react";

import { Image, StyleSheet, View } from "react-native";
import { connect } from "react-redux";

const AVATARS = {
  parents: require("../assets/avatars/parents.png"),
  partner: require("../assets/avatars/partner.png"),
  children: require("../assets/avatars/children.png")
};

class DependencyAvatarCustom extends React.Component {
  static propTypes = {
    dependent: PropTypes.oneOf(["parents", "partner", "children"]).isRequired
  };

  render() {
    const { dependent, themeColors } = this.props;

    return (
      <View style={[ styles.avatarView, {
        backgroundColor: themeColors.lightestPrimary
      }]}>
        <Image
          source={AVATARS[dependent]}
          style={styles.avatar}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  avatarView: {
    borderRadius: 30,
    height: 60,
    width: 60,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  avatar: {
    height: 40,
    width: 40
  }
});

export default connect(state => ({
  themeColors: state.themeColors
}))(DependencyAvatarCustom);
